import type { RequestStatus, QuoteStatus, JobStatus, VideoStatus, Priority } from '@/types';

export const SERVICES = [
  'İnşaat Sonrası Temizlik',
  'Villa Temizliği',
  'Residence Temizliği',
  'Plaza / Ofis Temizliği',
  'Yazlık Ev Temizliği',
  'Koltuk Yıkama',
];

export const REGIONS = [
  'İstanbul Avrupa',
  'İstanbul Anadolu',
  'Silivri',
  'Tekirdağ',
  'Ankara',
];

export const SOURCES = [
  'WhatsApp',
  'Instagram',
  'Facebook',
  'Website',
  'Referans',
  'Manuel',
];

export const RESPONSIBLES = [
  'Burak Yıldız',
  'Deniz Acar',
  'Ece Demirci',
  'Kaan Arslan',
];

export const PRIORITIES: Priority[] = ['Yüksek', 'Orta', 'Normal'];

export const REQUEST_STATUSES: RequestStatus[] = [
  'Yeni Talep',
  'Video Bekleniyor',
  'Video Geldi',
  'Değerlendiriliyor',
  'Teklif Hazırlanacak',
  'Teklif Gönderildi',
  'Müşteri Cevabı Bekleniyor',
  'Onaylandı',
  'Reddedildi',
  'Ulaşılamadı',
  'İptal',
];

export const PIPELINE_COLUMNS: RequestStatus[] = [
  'Yeni Talep',
  'Video Bekleniyor',
  'Video Geldi',
  'Değerlendiriliyor',
  'Teklif Hazırlanacak',
  'Teklif Gönderildi',
  'Müşteri Cevabı Bekleniyor',
  'Onaylandı',
];

export const VIDEO_STATUSES: VideoStatus[] = ['Video Yok', 'Video Bekleniyor', 'Video Geldi'];

export const QUOTE_STATUSES: QuoteStatus[] = [
  'Taslak',
  'Hazırlandı',
  'Müşteriye Gönderildi',
  'Cevap Bekleniyor',
  'Onaylandı',
  'Revize İstendi',
  'Reddedildi',
  'İptal',
];

export const JOB_STATUSES: JobStatus[] = [
  'Planlandı',
  'Hazırlanıyor',
  'Yola Çıkıldı',
  'Adrese Varıldı',
  'İş Başladı',
  'İş Devam Ediyor',
  'İş Tamamlandı',
  'Müşteri Kontrolü',
  'Kapandı',
];

export const APPOINTMENT_STATUSES = [
  'Planlandı',
  'Onay Bekleniyor',
  'Kesinleşti',
  'Hazırlanıyor',
  'Yola Çıkıldı',
  'İş Başladı',
  'Tamamlandı',
  'Ertelendi',
  'İptal',
];

export const PAYMENT_METHODS = ['Nakit', 'Havale / EFT', 'Kredi Kartı', 'Diğer'];

export const EXPENSE_CATEGORIES = [
  'Temizlik Malzemesi',
  'Personel',
  'Ulaşım',
  'Yakıt',
  'Ekipman',
  'Bakım',
  'Reklam',
  'Ofis',
  'Diğer',
];